// *******************************************************************************
// 1.0 - Team Info Modal
// *******************************************************************************

// **********************************************************
// Open Modal
// **********************************************************

attachEvent('.person-card--with-modal', 'click', (ev) => {
  const parentEle = ev.target.closest('[modal-parent]');
  const teamInfoModal = parentEle.querySelector('.team-info-modal');
  teamInfoModal.classList.add('is-open-modal');
  toggleBodyScrollLock(true);
  ev.preventDefault();
});

// **********************************************************
// Close Modal When Escape Key Press
// **********************************************************

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') {
    const modalElem = document.querySelectorAll('.team-info-modal');
    modalElem.forEach((el) => {
      el.classList.remove('is-open-modal');
      toggleBodyScrollLock(false);
    });
  }
});

// **********************************************************
// Close Modal When Click On Outside
// **********************************************************

attachEvent('.team-info-modal__close,.team-info-modal__overlay', 'click', (ev) => {
  const parentEle = ev.target.closest('.team-info-modal');
  parentEle.classList.remove('is-open-modal');
  toggleBodyScrollLock(false);
  ev.preventDefault();
});
